import request from '@/utils/request';

export function getCountryCode(params) {
  return request({
    url: `/locations/${params.longitude},${params.latitude}/countrycode/`,
    method: 'get',
    data: params
  });
}
